export default __webpack_public_path__ + "alberta-activities-sort-current.b1fd52f7305a9f324c59.svg";